<script lang="ts">
import type { Third } from "../Model/Third";

    import { thirdsService } from "../services";
    
        export let id : string;
        export let list : boolean;
        export let link: boolean;
    
        let name: string = 'Sin tercero adherido';
        let third: Third;
    
        $: getName(id)
    
        async function getName(id:string){

            if (!id) return;

            third = await thirdsService.findOne(id);
    
            if (third) {
                name = third.name + ' ' + third.surname1 + ' ' + third.surname2;
            }
        }
    
    </script>
    
    {#if list}
        <ul>
            <li>
                {#if third}
                    {#if link}
                        <a href="/tercero/{third.id}">{name}</a>
                    {:else}
                        {name}
                    {/if}
                {:else}
                    {name}
                {/if}
            </li>
        </ul>
    {:else}
        {#if third}
            {#if link}
                <a href="/tercero/{third.id}">{name}</a>
            {:else}
                {name}
            {/if}
        {:else}
            {name}
        {/if}
    {/if}